let read_more = document.querySelectorAll(
  ".product-description-container[read-more-qf]"
);

read_more.forEach((el) => {
  let read_more_control = el.querySelector(".read-more");
  let excerpt = el.querySelector("span.excerpt");
  let full = el.querySelector("span.full");

  read_more_control.addEventListener("click", () => {
    if (el.classList.contains("active")) {
      el.classList.remove("active");
      read_more_control.innerHTML = "Read more";
    } else {
      el.classList.add("active");
      read_more_control.innerHTML = "Read less";
    }
  });
});
